import { styled, Theme } from '@mui/material';

import { jpgPath } from '../../helpers/asset-factory';
import Image from '../image';

export const ProductImage = styled(Image)`
  & [data-main-image] {
    object-fit: cover !important;
  }
`;

export const getImages = (assetId: string, theme: Theme) => [
  {
    src: jpgPath(assetId, 300, 300),
    media: `(max-width: ${theme.breakpoints.values.md - 1}px)`,
    width: 300,
    height: 300,
  },
  {
    src: jpgPath(assetId, 500, 500),
    media: `(min-width: ${theme.breakpoints.values.md}px)`,
    width: 500,
    height: 500,
  },
];
